import { lazy } from 'react';
import { Route } from 'react-router-dom';
import { AdminLayout } from '@/layouts/AdminLayout';
import { AdminRoute } from '@/components/common/routes';

const AdminDashboard = lazy(() => import('@/pages/admin/DashboardPage').then((m) => ({ default: m.AdminDashboard })));
const AdminPayouts = lazy(() => import('@/pages/admin/PayoutsPage').then((m) => ({ default: m.AdminPayouts })));
const AdminSuppliers = lazy(() => import('@/pages/admin/SuppliersPage').then((m) => ({ default: m.AdminSuppliers })));
const AdminSupplierDetail = lazy(() =>
  import('@/pages/admin/SupplierDetailPage').then((m) => ({ default: m.AdminSupplierDetail }))
);
const AdminPartners = lazy(() => import('@/pages/admin/PartnersPage').then((m) => ({ default: m.AdminPartnersPage })));
const AdminPartnerDetail = lazy(() =>
  import('@/pages/admin/PartnerDetailPage').then((m) => ({ default: m.AdminPartnerDetailPage }))
);
const AdminTours = lazy(() => import('@/pages/admin/ToursPage').then((m) => ({ default: m.AdminTours })));
const AdminTourDetail = lazy(() =>
  import('@/pages/admin/TourDetailPage').then((m) => ({ default: m.AdminTourDetailPage }))
);
const AdminBookings = lazy(() => import('@/pages/admin/BookingsPage').then((m) => ({ default: m.AdminBookings })));
const AdminReviews = lazy(() => import('@/pages/admin/ReviewsPage').then((m) => ({ default: m.AdminReviews })));
const AdminTravelers = lazy(() => import('@/pages/admin/TravelersPage').then((m) => ({ default: m.AdminTravelers })));
const AdminCategories = lazy(() => import('@/pages/admin/ContentsPage').then((m) => ({ default: m.AdminCategories })));
const AdminLocations = lazy(() => import('@/pages/admin/LocationsPage').then((m) => ({ default: m.AdminLocations })));
const AdminLegalDocuments = lazy(() =>
  import('@/pages/admin/LegalDocumentsPage').then((m) => ({ default: m.AdminLegalDocumentsPage }))
);
const AdminAnalytics = lazy(() => import('@/pages/admin/AnalyticsPage').then((m) => ({ default: m.AdminAnalytics })));
const AdminTickets = lazy(() => import('@/pages/admin/TicketsPage').then((m) => ({ default: m.AdminTickets })));
const AdminChat = lazy(() => import('@/pages/admin/ChatPage').then((m) => ({ default: m.AdminChat })));
const AdminBlogs = lazy(() => import('@/pages/admin/BlogsPage').then((m) => ({ default: m.AdminBlogs })));
const AdminBlogEdit = lazy(() =>
  import('@/pages/admin/BlogEditPage').then((m) => ({ default: m.AdminBlogEditPage }))
);

export const adminRoutes = (
  <Route element={<AdminRoute />}>
    <Route element={<AdminLayout />}>
      <Route path="/admin" element={<AdminDashboard />} />
      <Route path="/admin/payouts" element={<AdminPayouts />} />
      <Route path="/admin/suppliers" element={<AdminSuppliers />} />
      <Route path="/admin/suppliers/:id" element={<AdminSupplierDetail />} />
      <Route path="/admin/partners" element={<AdminPartners />} />
      <Route path="/admin/partners/:id" element={<AdminPartnerDetail />} />
      <Route path="/admin/tours" element={<AdminTours />} />
      <Route path="/admin/tours/:id" element={<AdminTourDetail />} />
      <Route path="/admin/bookings" element={<AdminBookings />} />
      <Route path="/admin/reviews" element={<AdminReviews />} />
      <Route path="/admin/travelers" element={<AdminTravelers />} />
      <Route path="/admin/categories" element={<AdminCategories />} />
      <Route path="/admin/locations" element={<AdminLocations />} />
      <Route path="/admin/blogs" element={<AdminBlogs />} />
      <Route path="/admin/blogs/new" element={<AdminBlogEdit />} />
      <Route path="/admin/blogs/:id" element={<AdminBlogEdit />} />
      <Route path="/admin/legal" element={<AdminLegalDocuments />} />
      <Route path="/admin/analytics" element={<AdminAnalytics />} />
      <Route path="/admin/tickets" element={<AdminTickets />} />
      <Route path="/admin/chat" element={<AdminChat />} />
      <Route path="/admin/chat/:userId" element={<AdminChat />} />
    </Route>
  </Route>
);
